import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UserService } from '../services/user.service';
import { AdminService } from '../services/admin.service';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { TradingService } from '../services/trading.service';
const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-addeditadminlist',
    templateUrl: './addeditadminlist.component.html',
    styleUrls: ['./addeditadminlist.component.css']
})
export class AddEditAdminlist implements OnInit {
    element: any = {};
    createMode = true;
    phonecodelist: any[] = []
    countries: any[] = []
    countryListSearchCopy: any[] = []
    grouplist: any = []
    myForm: any = FormControl;
    constructor(
        public dialogRef: MatDialogRef<AddEditAdminlist>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private userService: UserService,
        private notifSer: NotificationsService,
        public fb: FormBuilder,
        private adminService: AdminService,
        private tradingService: TradingService) {
        this.element = data;

        this.myForm = this.fb.group({
            name: ['', [Validators.required]],
            short_name: ['', [Validators.required]],
            email: ['', [Validators.required]],
            country: ['', [Validators.required]],
            group: ['', [Validators.required]],
            gender: ['', [Validators.required]],
            phonecode: [''],
            phone: [''],

        });

    }
    ngOnInit() {
        this.getCountry();
        this.getUserGroup();
    }
    getCountry() {
        this.userService.country().subscribe(res => {
            var arr = res.sort(this.sort_by("phonecode", true, parseInt));
            var result = arr.reduce((unique, o) => {
                if (!unique.some(obj => obj.phonecode === o.phonecode)) {
                    unique.push(o);
                }
                return unique;
            }, []);
            this.phonecodelist = result;
        }, (err) => {
            console.log(err);
        });
        this.userService.country().subscribe(res => {
            this.countries = res;
            this.countryListSearchCopy = res;
            this.countries.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        }, (err) => {
            console.log(err);
        });
    }
    sort_by(field, reverse, primer) {
        var key = primer ?
            function (x) { return primer(x[field]) } :
            function (x) { return x[field] };

        reverse = [-1, 1][+!!reverse];

        return function (a, b) {
            return a = key(a), b = key(b), reverse * (+(a > b) - +(b > a));
        }
    }
    countryFilter(event: any) {
        console.log(event);
        let term = event;
        this.countries = this.countryListSearchCopy.filter(function (tag) {
            if (tag.name.toLowerCase().indexOf(term.toLowerCase()) >= 0 || tag.name.toLowerCase().indexOf(term.toLowerCase()) >= 0) {
                return tag;
            }
        });
    }
    onOptionSelected(event: MatAutocompleteSelectedEvent) {
        this.myForm.value['country'] = event.option.value
    }
    getUserGroup() {
        const { notif } = defaults;
        this.adminService.getUserGroups().subscribe((success) => {
            this.grouplist = success;
        }, (error) => {
            this.notifSer.error(
                'User Group',
                error.error.message,
                notif
            )
        })

    }
    async saveEditAdminlist() {
        this.userService.csrf().subscribe(data => {
            const { notif } = defaults
            this.myForm.value['_csrf'] = data['_csrf'];
            this.myForm.value['password'] = '';
            
            if (this.myForm.valid && this.element.mode == 'create') {
                this.userService.addNewCustomer(this.myForm.value).subscribe(data => {
                    if (data.status) {
                        this.notifSer.success('Success', data.message, notif)
                        // Emit the form data when closing the dialog

                        this.dialogRef.close({ success: true, data: data });

                    } else this.notifSer.error('Error', data.message, notif);
                }, err => this.notifSer.error('Error', err.error.message, notif))
            } else if (this.myForm.valid && this.element.mode === 'edit') {
                this.myForm.value['_id'] = this.element['_id'];
                this.myForm.value['liquidity'] = {};
                console.log(this.myForm.value, 'formvalue');
                this.tradingService.updateAdminUser(this.myForm.value).subscribe((success) => {
                    this.notifSer.success(
                        'Update User',
                        'Updated Admin User',
                        notif
                    )
                    this.dialogRef.close({ success: true, data: data });
                }, (error) => {
                    if (typeof error.error.message === 'object') {
                        // this.errorObj = error.error.message;
                    } else {
                        this.notifSer.error(
                            'Error',
                            error.error.message,
                            notif
                        )
                    }
                })
            }
        })

    }

    updateAdminUser() {
        const { notif } = defaults;
        this.myForm.value['liquidity'] = {};
        this.tradingService.updateAdminUser(this.myForm.value).subscribe((success) => {
            this.notifSer.success(
                'Update User',
                'Updated Admin User',
                notif
            )
        }, (error) => {
            if (typeof error.error.message === 'object') {
                // this.errorObj = error.error.message;
            } else {
                this.notifSer.error(
                    'Error',
                    error.error.message,
                    notif
                )
            }
        })
    }

}


// WEBPACK FOOTER //
// ./src/app/addeditadminlist/addeditadminlist.component.ts